import { ImagePathNode } from "../constants";



export function getImageUrl(src) {
  if (!src) return '';

  // If it's already an absolute URL, just return it
  if (src?.startsWith('http://') || src?.startsWith('https://')) {
    return src;
  }

  // If it's a backend upload path
  if (src?.startsWith('/uploads')) {
    return `${ImagePathNode}${src}`;
  }

  // Otherwise, assume it's a local or public asset
  return src;
}
